export function Logo({ size = 34, showText = true }) {
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="app-logo">
      <div
        className="rounded-[10px] bg-primary flex items-center justify-center shadow-lg shadow-primary/30"
        style={{ width: size, height: size }}
      >
        <div className="grid grid-cols-2 gap-[3px]">
          {[0, 1, 2, 3].map((i) => (
            <span
              key={i}
              className="rounded-[3px] bg-white/85"
              style={{ width: size * 0.24, height: size * 0.24 }}
            />
          ))}
        </div>
      </div>
      {showText && (
        <span className="font-display font-extrabold tracking-tight text-lg leading-none">
          <span className="text-primary">MW</span>
          <span className="text-foreground">CRMPRO</span>
        </span>
      )}
    </div>
  );
}
